import { Toast } from '../../enum/toast.enum';
import { finishLoading, startLoading, throwLoading } from '../slices/toasts';
import { AppThunk } from '../store';

export const withLoading = <T = never>(
  func: Function,
  errorMessage: string = Toast.error,
): AppThunk<Promise<T | void>> => async dispatch => {
  dispatch(startLoading());

  try {
    const result = await func();
    dispatch(finishLoading());
    return result;
  } catch (error) {
    dispatch(throwLoading(errorMessage));
  }
};
